<template>
  <el-container class="indexhome">
    <el-header>
          <h3>{{$t('payment.paySuccess')}}!</h3>
          <span>{{$t('payment.hPayPlease')}}<br>
{{$t('payment.hPayGoBack')}}<br>
{{$t('payment.hPaySeeBalance')}}</span>
    </el-header>
    <el-main>
      <div class="payItem">
        <div class="flex_column bt">
          <p class="pary">{{$t('payment.hpayment')}}</p>
          <h3>$ {{payData.price}} USD</h3>
        </div>
        <div class="flex_column">
          <p class="pary">{{$t('payment.hdetail')}}</p>
          <h1>{{payData.title}}</h1>
          <p>{{$t('payment.price')}} $ {{payData.price}} USD</p>
          <p>{{$t('payment.hcredits')}} {{Number(payData.quantity)+Number(payData.extra_quantity)}}</p>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import store from '@/store/store'
export default {
  name: 'payList',
  data () {
    return {
      payData: {}
    }
  },
  created () {
    this.payData = JSON.parse(this.utils.getCookie('setPayData'))
    // this.getQuantity()
  },
  mounted () {
    // console.log(navigator.userAgent)
    // let phone = navigator.userAgent// 设备机型的相关信息
    // phone = phone.substring(phone.indexOf('(') + 1, phone.indexOf(';'))// 处理信息，输出iphone
    // console.log(phone)
    // var u = navigator.userAgent
    // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
    // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    // console.log(isAndroid)
    // console.log(isiOS)
    // this.shareForm.user_agent = isiOS ? 'iphone' : (isAndroid ? 'android' : '')
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .indexhome{
    width: 100vw;
    margin: 0 auto;
  }
  #intercom-frame{
    display: none;
  }
  .el-header{
      width: 100vw;
      height:auto!important;
      padding: 25px 20px 0;
      font-family: Sofia Pro-Regular;
      font-size: 28px;
      font-weight: 400;
      text-align: left;
      color: #353643;
      text-align: center;
      span{
        font-size: 18px;
        color: #FF6440;
        margin-top:18px;
        display: inline-block;
        font-family: Roboto;
      }
  }
  .el-main{
    // overflow-y:scroll;
    padding:0 20px 20px;
    .payItem{
      // width: 100%;
      // height: 139px;
      background: #FFFFFF;
      border-radius: 12px;
      margin-top: 20px;
      padding: 0 22px;
      .flex_column{
        padding:20px 0;
        line-height: 36px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h3{
          font-size: 26px;
          p{
            font-size: 16px;
          }
        }
        h1{
            font-size: 16px;
        }
      }
      .pary{
        color: #697386;
      }
      .bt{
        border-bottom: 1px solid rgba(165, 165, 165, 0.5);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/toPay.vue